import { render } from "./AppFooter.vue?vue&type=template&id=4b4349d5&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"

import "./AppFooter.vue?vue&type=style&index=0&id=4b4349d5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4b4349d5"

export default script